import { compareLabel } from '~/util/compareLabel'

/** Dim names sort by the name itself (drives the Group-by dropdown + the "+ Filter" menu). */
export function sortDimNames(dims: string[]): string[] {
  return [...dims].sort(compareLabel)
}

export interface DimOption {
  value: string
  label: string
}

/** The 'any' aggregate sentinel is hidden from filter value pickers. */
export const ANY_SENTINEL = 'any'

/**
 * Filter value options: drop the `any` sentinel, dedup by raw `value` (first wins —
 * #7's dupe pairs are identical, so the kept label is stable), then sort by display label.
 */
export function cleanValueOptions(opts: DimOption[]): DimOption[] {
  const seen = new Set<string>()
  const out: DimOption[] = []
  for (const o of opts) {
    if (o.value === ANY_SENTINEL) continue
    if (seen.has(o.value)) continue
    seen.add(o.value)
    out.push(o)
  }
  return out.sort((a, b) => compareLabel(a.label, b.label))
}
